import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabaseClient";

export default function useDynamicPromoIcon() {
  const [promoIconUrl, setPromoIconUrl] = useState(null);
  const [promoText, setPromoText] = useState("🔥 Hot Deals!");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchPromoData = async () => {
      try {
        /**
         * Strategy:
         * - Use profitable + recent products
         * - Only existing DB columns
         * - Avoid 400 errors permanently
         */
        const { data, error } = await supabase
          .from("products")
          .select("name, image, images, profit, created_at")
          .order("profit", { ascending: false, nullsFirst: false })
          .order("created_at", { ascending: false })
          .limit(2);

        if (error) throw error;

        if (!isMounted || !data || data.length === 0) {
          setPromoIconUrl("/logo.png");
          return;
        }

        const product = data[0];

        /**
         * Resolve image safely (jsonb friendly)
         */
        const resolvedImage =
          product?.image?.url ||
          (Array.isArray(product?.image) ? product.image[0] : null) ||
          (Array.isArray(product?.images) ? product.images[0] : null) ||
          "/logo.png";

        /**
         * Promo copy
         */
        const phrases = [
          `🔥 ${product.name} is trending now!`,
          `⚡ Best value: ${product.name}`,
          `🎉 Hot deal you don’t want to miss`,
          `💥 Popular pick right now`,
        ];

        const randomText =
          phrases[Math.floor(Math.random() * phrases.length)];

        if (isMounted) {
          setPromoIconUrl(resolvedImage);
          setPromoText(randomText);
        }
      } catch (err) {
        console.error("Promo icon fetch failed:", err);
        if (isMounted) {
          setPromoIconUrl("/logo.png");
          setPromoText("🔥 Hot Deals!");
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchPromoData();

    return () => {
      isMounted = false;
    };
  }, []); // ✅ correct dependency array

  return {
    promoIconUrl,
    promoText,
    isLoading,
  };
}
